import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    uploadMarkersAsComments: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for uploading markers as comments */
            uploadMarkersAsComments: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "UploadMarkersRow.uploadMarkersAsComments?c=3gxa0abqycort", defaultMessage: "Upload Markers as Comments" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
